<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <b class="d-block mb-1"> Tipo de Transporte </b>
      <v-btn-toggle
        :value="data.type"
        @change="setKey('type', $event)"
        color="primary"
        class="w-full"
        mandatory
      >
        <v-btn
          v-for="item in modalTypes"
          :key="item.id"
          :value="item.id"
          class="flex-1"
          small
          :disabled="readonly"
        >
          {{ item.name }}
        </v-btn>
      </v-btn-toggle>

      <v-card
        v-if="data.type.includes('car_rented')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Aluguel de Carro</b>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.pickup_location"
              @input="setKey('pickup_location', $event)"
              label="Local de retirada"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Local de retirada é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.start_date"
              @input="setKey('start_date', $event)"
              label="Data de Início"
              type="date"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Data de Início é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.end_date"
              @input="setKey('end_date', $event)"
              label="Data de Fim"
              type="date"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Data de Fim é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.rental_price"
              @input="setKey('rental_price', $event, parseFloat)"
              label="Preço do Aluguel"
              prefix="R$"
              type="number"
              outlined
              dense
              hide-details
              :disabled="readonly"
            />
          </v-col>
        </v-row>
      </v-card>

      <v-card
        v-if="data.type.includes('car')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Consumo de Combustível</b>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.km"
              @input="setKey('km', $event, parseInt)"
              label="Percurso em Km"
              append-icon="mdi-map-marker"
              type="number"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Km é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.km_per_litre"
              @input="setKey('km_per_litre', $event, parseFloat)"
              label="Consumo em Km/L"
              append-icon="mdi-gas-station"
              type="number"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Km/L é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              :value="data.gas_type"
              @input="setKey('gas_type', $event)"
              :items="gasTypes"
              label="Tipo de Combustível"
              outlined
              dense
              hide-details
              item-text="name"
              item-value="id"
              :rules="[(v) => !!v || 'Tipo de Combustível é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.gas_price"
              @input="setKey('gas_price', $event, parseFloat)"
              label="Preço do Combustível"
              prefix="R$"
              type="number"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Preço do Combustível é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.toll_price"
              @input="setKey('toll_price', $event, parseFloat)"
              label="Preço de Pedágio"
              prefix="R$"
              type="number"
              outlined
              dense
              hide-details
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.parking_price"
              @input="setKey('parking_price', $event, parseFloat)"
              label="Preço de Estacionamento"
              prefix="R$"
              type="number"
              outlined
              dense
              hide-details
              :disabled="readonly"
            />
          </v-col>
        </v-row>
      </v-card>

      <v-card
        v-if="data.type.includes('bus')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Passagens</b>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.bus_company"
              @input="setKey('bus_company', $event)"
              label="Empresa de Ônibus"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Empresa de Ônibus é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.ticket_price"
              @input="setKey('ticket_price', $event, parseFloat)"
              label="Preço da Passagem"
              prefix="R$"
              type="number"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Preço da Passagem é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
        </v-row>
      </v-card>

      <v-text-field
        :value="data.other_price"
        @input="setKey('other_price', $event, parseFloat)"
        label="Outros custos"
        hint="Apenas relacionados ao transporte"
        prefix="R$"
        class="mt-4"
        outlined
        dense
        :disabled="readonly"
      />
      <v-textarea
        v-if="data.other_price && data.other_price > 0"
        :value="data.other_description"
        @input="setKey('other_description', $event)"
        label="Descrição dos outros custos"
        hide-details
        rows="2"
        outlined
        dense
        :rules="[(v) => !!v || 'Descrição dos outros custos é obrigatório']"
        :disabled="readonly"
      />
    </v-form>
  </div>
</template>

<script>
const defaultData = () => {
  return {
    type: "car",
    // car
    km: null,
    km_per_litre: null,
    gas_type: null,
    gas_price: null,
    toll_price: null,
    parking_price: null,
    // car rental
    rental_price: null,
    pickup_location: null,
    start_date: null,
    end_date: null,

    // bus
    bus_company: null,
    ticket_price: null,

    // other
    other_price: null,
    other_description: null,
  };
};

export const manifest = {
  id: "TRANSPORT",
  name: "Transporte",
  icon: "mdi-car",
  description: "Transporte",
  defaultData: defaultData,
};

export default {
  name: "TransportEditor",
  props: {
    value: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      modalTypes: [
        { id: "car", name: "Carro Particular" },
        // { id: "car_company", name: "Carro Empresa" },
        { id: "car_rented", name: "Carro Alugado" },
        { id: "bus", name: "Ônibus" },
      ],
      gasTypes: [
        { id: "gasoline", name: "Gasolina" },
        { id: "diesel", name: "Diesel" },
        { id: "electric", name: "Elétrico" },
      ],
    };
  },
  methods: {
    setKey(key, value, parse = false) {
      this.data = {
        ...this.data,
        [key]: !value ? value : parse ? parse(value) : value,
      };
    },
    getTotal() {
      let value = 0;
      if (this.data.type.includes("car")) {
        value += (this.data.km / this.data.km_per_litre) * this.data.gas_price;
        value += this.data.toll_price || 0;
        value += this.data.parking_price || 0;
      }

      if (this.data.type.includes("car_rented"))
        value += this.data.rental_price;

      if (this.data.type.includes("bus")) value += this.data.ticket_price;

      value += this.data.other_price || 0;

      return value;
    },
  },
  watch: {
    valid(value) {
      this.$emit("update:valid", value);
    },
    data: {
      handler(value) {
        this.$emit("update:amount", this.getTotal());
      },
      deep: true,
    },
  },
  computed: {
    data: {
      get() {
        return this.value || defaultData();
      },
      set(value) {
        this.$emit("update", value);
      },
    },
  },
  mounted() {
    this.$emit("update:valid", this.valid);
  },
};
</script>
